import { useState, useRef, useEffect } from 'react'
import styles from './Tooltip.module.css'

export const CustomTooltip = ({ children, content, position = 'top' }) => {
    const [isVisible, setIsVisible] = useState(false);
    const tooltipRef = useRef(null);
    const triggerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (tooltipRef.current && !tooltipRef.current.contains(event.target) &&
                triggerRef.current && !triggerRef.current.contains(event.target)) {
                setIsVisible(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const showTooltip = () => setIsVisible(true);
    const hideTooltip = () => setIsVisible(false);

    if (!content) {
        return children;
    }

    return (
        <div className={styles.tooltipWrapper}>
            <div
                ref={triggerRef}
                onMouseEnter={showTooltip}
                onMouseLeave={hideTooltip}
                className={styles.tooltipTrigger}
            >
                {children}
            </div>
            {isVisible && (
                <div
                    ref={tooltipRef}
                    className={`${styles.tooltipContent} ${styles[position]}`}
                >
                    {content}
                </div>
            )}
        </div>
    );
};


